import { useQuery } from '@tanstack/react-query'
import { usersControllerGetUserInfo } from 'api.gen'
import { useFeatureTogglesStore } from 'stores/featureTogglesStore'
import { useEffect } from 'react'

const fetchFeatureToggles = async () => {
  const response = await usersControllerGetUserInfo()
  if (response.status === 200) {
    return response.data.permission.feature_toggles
  }
  return {}
}

export const useFeatureToggles = () => {
  const { featureToggles, setFeatureToggles } = useFeatureTogglesStore()

  const { data, isLoading } = useQuery({
    queryKey: ['feature-toggles'],
    queryFn: fetchFeatureToggles
  })

  useEffect(() => {
    if (data) {
      setFeatureToggles(data)
    }
  }, [data, setFeatureToggles])

  return {
    featureToggles:
      Object.keys(featureToggles).length > 0 ? featureToggles : data ?? {},
    isLoadingFeatureTogglesData: isLoading
  }
}
